export default "__VITE_ASSET__Cshev7ZD__"